import { Navigate } from "react-router";
import { useGetProviderUserQuery } from "../../../apis/ProviderUser.api";
import { PrimaryProviderUser, ProviderUser } from "../../../types/models/ProviderUser";
import GradientCircularProgress from "../../../../share/components/progress/GradientCircularProgress";

export const ProviderUserScoped = () => {
    const {
        data,
    } = useGetProviderUserQuery(PrimaryProviderUser.fromPath('scoped'))

    if (data) {
        const url = `/dashboard/provider-users/${data.id}?scoped=true`
        return <Navigate to={url} replace/>
    } else {
        return <>
            <GradientCircularProgress/>
        </>
    }
}
export default ProviderUserScoped;
